import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectors as ListingsReducerSelectors } from "redux/slices/v2/ListingReducer";
import { COUNTRY_CONFIG } from "../../../../../../Config/country";
import Dropdown from "../DropDown/DropDown";
import InputSelect from "./InputSelect";
import classes from "./PriceRangeSelect.module.scss";

const MIN_PRICES_LIST_VENTE = [
  0, 250000, 500000, 750000, 1000000, 1500000, 2000000, 3000000, 5000000,
];

const MAX_PRICES_LIST_VENTE = [
  1000000, 2500000, 5000000, 7500000, 10000000, 15000000, 20000000, 30000000,
  50000000,
];

const MIN_PRICES_LIST_LOCATION = [
  0, 1000, 2500, 3500, 4500, 5500, 7000, 8000, 10000, 12000,
];

const MAX_PRICES_LIST_LOCATION = [
  6000, 7000, 8000, 9000, 10000, 12000, 15000, 17000, 18500, 20000,
];

export default function PriceRangeSelect({
  transactionType,
  onPriceRangeChange,
}: {
  transactionType: "Vente" | "Location" | "Projets Neufs" | "";
  onPriceRangeChange: ({
    minPrice,
    maxPrice,
  }: {
    minPrice?: number;
    maxPrice?: number;
  }) => void;
}) {
  const { t } = useTranslation("commonAnnonces");
  const searchPayload = useSelector(
    ListingsReducerSelectors.searchPayloadSelector
  );
  const [dropdownToggle, setDropdownToggle] = useState<boolean>(false);
  const [minValue, setMinValue] = useState(
    searchPayload?.prixmin ? searchPayload.prixmin : ""
  );
  const [maxValue, setMaxValue] = useState(
    searchPayload?.prixmax ? searchPayload.prixmax : ""
  );
  const [label, setLabel] = useState("Prix");
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 990) setIsMobile(true);
      else setIsMobile(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (window.innerWidth <= 990) setIsMobile(true);
    else setIsMobile(false);
  }, []);
  useEffect(() => {
    setLabel(
      `${
        searchPayload
          ? searchPayload.prixmin || searchPayload.prixmax
            ? valuesFormatters([searchPayload.prixmin, searchPayload.prixmax])
            : t("Prix")
          : t("Prix")
      }`
    );
  }, [searchPayload]);
  const intToShort = (value: number) => {
    value = parseInt(`${value}`);

    const suffixNum = parseFloat(`${`${value}`.length / 3}`);
    let shortValue = `${value}`;
    if (suffixNum > 1) {
      shortValue = (
        value / Math.pow(1000, parseInt(`${suffixNum}`))
      ).toPrecision(2);
    } else {
      shortValue = `${value}`;
    }
    return shortValue;
  };

  const intToSuffixe = (value: number) => {
    value = parseInt(`${value}`);

    const suffixes = ["", "K", "M", "MM", "t"];
    const suffixNum = parseFloat(`${`${value}`.length / 3}`);

    if (suffixNum === 1) {
      return suffixes[parseInt(`${suffixNum}`) - 1];
    } else {
      return suffixes[parseInt(`${suffixNum}`)];
    }
  };

  const valuesFormatters = (selected: any[]) => {
    if (selected[0] && selected[1]) {
      return `${intToShort(selected[0])}${intToSuffixe(
        selected[0]
      )} - ${intToShort(selected[1])}${intToSuffixe(selected[1])} ${t(
        COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY].CURRENCY
      )}`;
    } else if (selected[0]) {
      return `> ${intToShort(selected[0])}${intToSuffixe(selected[0])} ${t(
        COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY].CURRENCY
      )}`;
    } else if (selected[1]) {
      return `< ${intToShort(selected[1])}${intToSuffixe(selected[1])} ${t(
        COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY].CURRENCY
      )}`;
    }
    return t("Prix");
  };

  // <RangeSelect
  //   // valuesFormatters={valuesFormatters}
  //   label={t("Prix")}
  //   minValuesList={
  //     transactionType === "Vente"
  //       ? MIN_PRICES_LIST
  //       : MIN_PRICES_LIST.map((p) => p / 100)
  //   }
  //   maxValuesList={
  //     transactionType === "Vente"
  //       ? MAX_PRICES_LIST
  //       : MAX_PRICES_LIST.map((p) => p / 100)
  //   }
  //   onRangeSelect={({ minValue, maxValue }) => {
  //     setDropdownToggle(false);
  //     onPriceRangeChange({ minPrice: minValue, maxPrice: maxValue });
  //   }}
  //   defaultMinValue={
  //     searchPayload
  //       ? searchPayload.prixmin
  //         ? searchPayload.prixmin
  //         : ""
  //       : ""
  //   }
  //   defaultMaxValue={
  //     searchPayload
  //       ? searchPayload.prixmax
  //         ? searchPayload.prixmax
  //         : ""
  //       : ""
  //   }
  //   unit={t(COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY].CURRENCY)}
  // />
  const contentComponent = (
    <div style={{ padding: 0, margin: 0 }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className={classes.componentTitle}>
          <span className={classes.title}>{t("Prix")}</span>
        </div>
        <div className={classes.max_min_container} style={{ height: "94px" }}>
          <div className={classes.maximum_prix}>
            <span className={classes.prix_text}>{t("Minimum")}</span>
            <div style={{ width: "100%", height: "44px" }}>
              <InputSelect
                array={
                  searchPayload.transaction_type == "Location"
                    ? MIN_PRICES_LIST_LOCATION
                    : MIN_PRICES_LIST_VENTE
                }
                defaultValue={minValue}
                setDefaultValue={setMinValue}
                placeHolder={t("0 MAD")}
                maxValue={9999999999999}
                name="minValueInput"
                symbol={t("MAD")}
              />
            </div>
          </div>
          <div className={classes.separator_container}>
            <span className={classes.separator}>-</span>
          </div>
          <div className={classes.maximum_prix}>
            <span className={classes.prix_text}>{t("Maximum")}</span>
            <div style={{ width: "100%", height: "44px" }}>
              <InputSelect
                array={
                  searchPayload.transaction_type == "Location"
                    ? MAX_PRICES_LIST_LOCATION
                    : MAX_PRICES_LIST_VENTE
                }
                defaultValue={maxValue}
                setDefaultValue={setMaxValue}
                placeHolder={t("Aucun")}
                maxValue={9999999999999}
                name="maxValueInput"
                symbol={t("MAD")}
              />
            </div>
          </div>
        </div>
        <div className={classes.validBtnWrapper}>
          <span
            className={classes.validBtn}
            onClick={() => {
              setDropdownToggle(false);
              onPriceRangeChange({
                minPrice: parseInt(minValue.toString()),
                maxPrice: parseInt(maxValue.toString()),
              });
            }}
          >
            {t("Valider")}
          </span>
        </div>
      </div>
    </div>
  );

  const valueComponent = <span className={classes.label}>{t(label)}</span>;

  return (
    <>
      <Dropdown
        liststyling={!isMobile ? classes.liststyling : ""}
        className={`${classes.btnWrapper} ${
          searchPayload
            ? searchPayload.prixmin || searchPayload.prixmax
              ? classes.btnWrapperActive
              : ""
            : ""
        }`}
        t={t}
        contentComponent={contentComponent}
        valueComponent={valueComponent}
        toggleBtnStyle={classes.toggleBtnStyle}
        onToggleActive={classes.toggleBtnActive}
        dropdownToggle={dropdownToggle}
        setDropdownToggle={setDropdownToggle}
      />
    </>
  );
}
